const GET_POSITIONS_SUCCEEDED = 'GET_POSITIONS_SUCCEEDED'
const GET_POSITIONS_FAILED = 'GET_POSITIONS_FAILED'

export {GET_POSITIONS_SUCCEEDED, GET_POSITIONS_FAILED}